export var filteredPath = function (introPath) {
    var locations = '';
    var newPaths = introPath.filter(function (item) { return item != ''; });
    if (newPaths[0] == 'apps') {
        if (newPaths[1] == 'groups' || newPaths[1] == 'admins') {
            var groupRegex_1 = /\d\b/;
            newPaths.forEach(function (item) {
                if (groupRegex_1.test(item)) {
                    locations += '/id';
                }
                else {
                    locations += "/".concat(item);
                }
            });
        }
        else {
            var numberReg_1 = /^\d+$/;
            var lowerAndUpperId_1 = /(?=.*[a-z])(?=.*\d)/;
            newPaths.forEach(function (item) {
                if (numberReg_1.test(item) || lowerAndUpperId_1.test(item)) {
                    locations += '/id';
                }
                else {
                    locations += "/".concat(item);
                }
            });
        }
    }
    else if (newPaths[0] == 'organizations' || newPaths[0] == 'partner') {
        var numberReg_2 = /^\d+$/;
        var lowerLetter_1 = /(?=.*[a-z])(?=.*[A-Z]{2})/;
        newPaths.forEach(function (item) {
            if (lowerLetter_1.test(item) || numberReg_2.test(item)) {
                locations += '/id';
            }
            else {
                locations += "/".concat(item);
            }
        });
    }
    return locations.toLowerCase();
};
